import { Injectable, LOCALE_ID, inject } from '@angular/core';
import { changeUrlToLanguage, languages } from './languages';
import { LanguageServiceInterface } from './language.service.interface';
import { AuthService } from '../auth/auth.service';
import { firstValueFrom } from 'rxjs';
import { BackendService } from '../../api/bff/backend.service';

@Injectable({
  providedIn: 'root',
})
export class LanguageService implements LanguageServiceInterface {
  private localeId = inject(LOCALE_ID);
  private authService = inject(AuthService);
  private backend = inject(BackendService);

  public getCurrentLocale(): string {
    return this.localeId;
  }

  public async setLanguage(code: string) {
    const lang = languages.find((l) => l.code === code);
    if (!lang) return;
    const user = await this.authService.user;
    if (user) {
      // Update the user's language
      await firstValueFrom(this.backend.putUser({ ...user, language: lang.code }));
    }

    changeUrlToLanguage(lang.code);
  }
}
